import InnerComponent from '@Components/Sales/PackingSlip/ViewPackingSlip';
import orgContainer from '@Components/AppContainer';

const ViewPackingSlip = () => ((orgContainer(InnerComponent)));
export default ViewPackingSlip;